import Axios from "axios";
import { getApiUrl } from "./commanFunc";


export const apiInst = Axios.create({
    baseURL: getApiUrl(),
});

export function updateApiBaseUrl(newUrl, region) {
    // Update the Axios instance for future calls
    apiInst.defaults.baseURL = newUrl;
    // Persist for page refreshes
    window.localStorage.setItem('api_base_url', newUrl);
    window.localStorage.setItem('api_region', region);
}

const authHeader = () => ({
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${JSON.parse(window.localStorage.getItem('user')).jwt}`,
        "Cache-Control": "no-cache",
    },
    storeid: JSON.parse(window.localStorage.getItem('ds'))
});

// export const crashLink = url + "/admin";
export const crashLink = () => `${getApiUrl()}/admin`;
export const supportEmail = "support@miirapos.com";

export const EqForm = async (data) => {
    try {
        const response = await apiInst.post('/enquieryForm', data);
        return response.data;
    } catch (error) {
        console.error('Get User Info Error:', error);
    }
}

const validationCheck = async (data, Logout) => {
    if (data.status === (401 || 406 || 404)) {
        // console.log('Need to go to logout Function');
        Logout(data.status);
    }
    else if (data.status === 500) {
        // console.log('Need to go to logout Function from 50000');
        Logout(data.status);
    }
    return data.data;
}

export const getUserInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/userInfo', data, authHeader());
        return response.data;
    } catch (error) {
        console.error('Get User Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getPaymentStatus = (sessionId) => {
    return fetch(`${getApiUrl()}/api/stripe/payment-status`, {
        method: "POST", // Use POST method
        headers: {
            'Content-Type': 'application/json', // Specify the content type
        },
        // Send the session ID in the request body
        body: JSON.stringify(sessionId)
    })
        .then((res) => {
            // console.log(res);
            if (!res.ok) {
                throw new Error("Failed to fetch payment status.");
            }
            return res.json();
        })
        .then((data) => {
            // console.log(data);
            if (!data.status) {
                throw new Error("Payment status not received in response.");
            }
            return data;
        });
};

export const getINPaymentStatus = (sessionId) => {
    return fetch(`${getApiUrl()}/api/inpay/get-sub-details`, {
        method: "POST", // Use POST method
        headers: {
            'Content-Type': 'application/json', // Specify the content type
        },
        // Send the session ID in the request body
        body: JSON.stringify(sessionId)
    })
        .then((res) => {
            console.log(res);
            if (!res.ok) {
                throw new Error("Failed to fetch payment status.");
            }
            return res.json();
        });
};



export const signupRestaurant = async (data) => {
    // console.log(`Sending Data To SignUP ${data}`);
    try {
        const response = await apiInst.post('/signup', { data });
        // console.log(response);
        return response.data;
    } catch (error) {
        // console.error('Signup Error:', error);
        return await validationCheck(error.response);
    }
}

export const loginRest = async (data, Logout) => {
    try {
        const response = await apiInst.post('/login', data);
        return response.data;
    } catch (error) {
        console.error('Login Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const forgotPasswordRequestRest = async (data, Logout) => {
    try {
        const response = await apiInst.post('/fgpreq', data);
        return response.data;
    } catch (error) {
        console.error('Forgot Password Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


export const verifyOtpRest = async (data, Logout) => {
    try {
        const response = await apiInst.post('/verify-otp', data);
        return response.data;
    } catch (error) {
        console.error('Verify OTP Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const resetPasswordRest = async (data, Logout) => {
    try {
        const response = await apiInst.post('/reset-password', data);
        return response.data;
    } catch (error) {
        console.error('Reset Password Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const checkUserEmail = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/checkEmail', data, authHeader());
        return response.data;
    } catch (error) {
        console.error('Check User Email Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const addStore = async (data, Logout) => {
    try {
        const response = await apiInst.post('/addStore', data, authHeader());
        return response.data;
    } catch (error) {
        console.error('Add Store Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getlistCatgory = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/listCatgory', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get List Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
// Handle  Dashboard API....
export const getDashboardData = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/dashboardData', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get List Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// ///**********All Menu Api Handling*********/
// Handle Menu page apis...
export const addMenu = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/addMenu', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const addMenuBulk = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/addMenuBulk', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Bulk Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


// Under Comman Api Hadler.....
export const getlistMenu = async (data, Logout) => {
    try {
        const response = await apiInst.post('/listMenu', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get List Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const editItemCall = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/editItem', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const editCatgCall = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/editCatgory', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const deleteItem = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/removeItem', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const deleteCategory = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/menu/removeCatgory', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

///*****End of Menu API Handling.... */

/// **** Following api to handle Inventory Page... */
export const getMenuInventory = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/invtry/getMenu', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
};

export const getInventoryLogsAPI = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/invtry/productRecords', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
};

export const linkMenuItemAPI = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/invtry/linkMenu', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
};

export const recordLogAPI = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/invtry/recordProductBlk', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
};
/// ***** End of Inventory Page API Handling... */

/// handle Online..
export const getOnlineInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/storeContent', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const updateOnlineInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/updateStoreContent', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}





// export const sendOrder = async (data, Logout) => {
//     try {
//         const response = await apiInst.post('/admin/sendOrder', data, authHeader());
//         return await validationCheck(response, Logout);
//     } catch (error) {
//         console.error('Send Order Error:', error);
//         return await validationCheck(error.response, Logout);
//     }
// }

// export const checkOut = async (data, Logout) => {
//     try {
//         const response = await apiInst.post('/admin/orderCheckout', data, authHeader());
//         return await validationCheck(response, Logout);
//     } catch (error) {
//         console.error('Check Out Error:', error);
//         return await validationCheck(error.response, Logout);
//     }
// }

// export const itemRemove = async (data, Logout) => {
//     try {
//         const response = await apiInst.post('/admin/removeItem', data, authHeader());
//         return await validationCheck(response, Logout);
//     } catch (error) {
//         console.error('Item Remove Error:', error);
//         return await validationCheck(error.response, Logout);
//     }
// }

export const ListStore = async (Logout) => {
    try {
        const response = await apiInst.post('/listStore', {}, authHeader());
        return response.data;
    } catch (error) {
        console.error('List Store Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const addUser = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/addUser', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const editUser = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/editUser', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Edit User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const listUser = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/listUser', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('List User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const getPaymentSettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getPaySetting', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('List User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const setPaymentSettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/setPaySetting', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('List User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const deleteUser = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/removeUser', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Delete User Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
/// ***** Setting Payment Section *****///

export const AddPayMeth = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/addPaymentMode', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const UpdatePayMeth = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/updatePaymentMode', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const DeletePayMeth = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/removePaymentMode', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Add Menu Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


export const saveLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/addLayout', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Save Layout Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const deleteLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/removeLayout', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Save Layout Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/layout', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get Layout Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// /** This is not need to change... as going direct to device api */
export const generateDeviceToken = async (data, Logout) => {
    try {
        const response = await apiInst.post('/device/generateToken', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Generate Device Token Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


export const getCurrentOrder = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/dailyOrder', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get currentOrder Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getBulkOrderData = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/dailyOrderBulk', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get Bulk Report Data Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
//****API handling for Report page */
export const getUserTimeLogAPI = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/reports/user-timelogs', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


///****End of Report Page */



//****API handling for general section in setting page */
export const getStoreConfig = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/getStoreConfig', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getStoreInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/storeInfo', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const editStoreInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/storeInfoEdit', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
// /*Handling device Apis... */
export const getdeviceInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/devices', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get Device Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const removeDevice = async (data, Logout) => {
    /// This will Handle all device Removal form Terminal, Printers, KDS, CLS
    try {
        const response = await apiInst.post('/admin/setting/removeDevice', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Remove Device Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const staChangeDevice = async (data, Logout) => {
    /// This will Handle all device Removal form Terminal, Printers, KDS, CLS
    try {
        const response = await apiInst.post('/admin/setting/update-device-status', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Remove Device Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

/*** API to handle api devices ***/
export const addPrinter = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/addPrinter', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Remove Device Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

/***API to handle Payment option in setting section */

export const getDevicePayment = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getPaymentInfo', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const getSubDetails = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getSubInfo', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

/**This is List all store user Punch's */

export const getPunchDetails = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/userTimeLogs', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get currentOrder Info Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Api to handle advance Setting....
export const getAdvanceInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getAdvInfo', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const setAdvanceInfo = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/setAdvsetting', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

// Api to handle Notification Settings
export const getNotificationSettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getNotificSett', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const setNotificationSettings = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/setNotificSett', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


export const getPrintLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/priLay/getPrinterLayouts', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const savePrintLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/priLay/savePrinterLayout', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
export const deletePrintLayout = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/priLay/removePrinterLayout', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}


export const getTimeLogs = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/getTimeLog', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const punchTime = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/setTimeLog', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}

export const deleteTimeLog = async (data, Logout) => {
    try {
        const response = await apiInst.post('/admin/setting/deleteTimeLog', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        console.error('Get StoreData loading Error:', error);
        return await validationCheck(error.response, Logout);
    }
}
// Side-Car (Modifier) Management
export const getSideCars = async (data, Logout) => {
    try {
        // GET request expects params in query
        const response = await apiInst.post(`admin/setting/sideCar/getSideCars`, data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        return await validationCheck(error.response, Logout);
    }
};

export const saveSideCar = async (data, Logout) => {
    try {
        // POST request for Create/Update
        const response = await apiInst.post('admin/setting/sideCar/saveSideCar', data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        return await validationCheck(error.response, Logout);
    }
};

export const removeSideCar = async (data, Logout) => {
    try {
        // DELETE request using query params as defined in Node.js router
        const response = await apiInst.post(`admin/setting/sideCar/removeSideCar`, data, authHeader());
        return await validationCheck(response, Logout);
    } catch (error) {
        return await validationCheck(error.response, Logout);
    }
};
